import request from "@/utils/request";

export default function agentOpenedAVipForWeChatBatch(data) {
  return request({
    url: `/device/memberMonthly/agentOpenedAVipForWeChatBatch`,
    method: "post",
    data,
  });
}
